import { Tooltip } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { formatDateAndHour } from "../utils/utils";

interface AvailabilityIndicatorsProps {
  lastUpdate?: Date;
  hasDelay: boolean;
}

export default function AvailabilityIndicators(
  props: AvailabilityIndicatorsProps
) {
  const { lastUpdate, hasDelay } = props;

  const getColor = (hasDelay: boolean | undefined) => {
    switch (hasDelay) {
      case false:
        return "green";
      case true:
        return "yellow";
      default:
        return "orange";
    }
  };

  const getMessage = (hasDelay: boolean | undefined) => {
    switch (hasDelay) {
      case false:
        return "Conexão Ativa";
      case true:
        return `Falha ao obter dados. Última tentativa de coleta em: ${formatDateAndHour(
          lastUpdate ?? new Date(),
          true
        )}`;
      default:
        return "Desconhecido";
    }
  };

  const color = getColor(hasDelay);
  const message = getMessage(hasDelay);

  return (
    <Tooltip title={message} arrow>
      <CircleIcon
        sx={{
          color: color,
          width: 16,
          height: 16,
          marginLeft: "8px",
        }}
      />
    </Tooltip>
  );
}
